import Component from 'flarum/common/Component';
/**
 * Simple horizontal bar chart - species-by-group and taxon-by-rank
 * breakdowns on /stats. Bars are sized relative to the largest value in the
 * set, not a fixed absolute scale, since counts here range from a handful
 * to several thousand - a shared scale keeps the small bars meaningfully
 * visible rather than vanishing next to a scale sized for the biggest one.
 *
 * attrs: { bars: [{key, label, value, color}], sort? }
 *
 * sort defaults to true (by value, descending - fine for the taxon-group
 * breakdown, an arbitrary set of 5 categories). Pass false to keep `bars`
 * in the order given instead - the rank breakdown needs that to read as an
 * actual taxonomic hierarchy (règne -> ... -> forme) rather than reshuffled
 * by whichever rank happens to have the most taxa.
 */
export default class StatsBarChart extends Component {
  view() {
    const bars = (this.attrs.bars || []).slice();
    if (this.attrs.sort !== false) bars.sort((a, b) => b.value - a.value);
    const maxValue = Math.max(...bars.map(b => b.value), 1);
    const format = v => new Intl.NumberFormat('fr-FR').format(v);
    return m("div", {
      className: "StatsBarChart"
    }, bars.map(bar => m("div", {
      key: bar.key,
      className: "StatsBarChart-row"
    }, m("span", {
      className: "StatsBarChart-label"
    }, bar.label), m("div", {
      className: "StatsBarChart-track"
    }, m("div", {
      className: "StatsBarChart-fill",
      style: {
        width: bar.value / maxValue * 100 + '%',
        background: bar.color
      }
    })), m("span", {
      className: "StatsBarChart-value"
    }, format(bar.value)))));
  }
}
flarum.reg.add('champis-others', 'forum/components/StatsBarChart', StatsBarChart);